module.exports = __webpack_public_path__ + "img/table-cell-1.png";